import React from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { Form, Button } from 'react-bootstrap';
import { MdPlayArrow } from "react-icons/md";

/* import context function */
import { useCheckbox } from '../context/checkContext';

/* import custom tools */
import timestamp from '../assecs/plugin/timestamp'; 

/* import function from store folder */
import { setModel } from '../store/components/modelSlice';

const TableList = ({ index = 0, targets, content, id, arrowSwitch, clickHandle }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const { selected, checkboxHandler } = useCheckbox();

    const indexElement = () => {
        let element = null;
        let hasArrow = content.slots?.length || content.amount?.length;
        
        element = index + 1;

        return (
            <td key='index'>
                { hasArrow && <MdPlayArrow is-open={`${ arrowSwitch }`} onClick={ clickHandle } /> }
                { element }
            </td>
        );
    }

    const linkElement = url => {
        let element = null;
        
        element = <a className='link' href={ url } target='_blank'>{ url }</a>

        return <td key='link'>{ element }</td>;
    };

    const imageElement = src => {
        let element = null;
        
        element = <img className='image' src={ src } alt={ src } />;

        return <td key='image'>{ element }</td>;
    };
    
    const buttonElement = event => {
        const random = Math.floor(Math.random()*(9990-1+1))+1;;
        const { element } = event;
        let elements = [];
        
        element.forEach(({ key, buttonType, elementType, text, modelType, hidden=false }) => {
            let _elements = null;
            const elementKey = content[key] || key;
            const variantType = elementType[elementKey];
            const buttonText = text[elementKey];
            const isHidden = hidden[elementKey] || hidden;

            if (! (isHidden === true)) {
                if (buttonType === 'page') 
                    _elements = <Button key={ `${buttonType}-button` } type='button' name={ buttonType } variant={ variantType } onClick={ transferHandler }>{ buttonText }</Button>;
                else {
                    const modelTypeName = modelType[elementKey];

                    _elements = <Button key={ `${variantType}-button` } type='button' name={ buttonType } variant={ variantType } onClick={ () => modelHandler(modelTypeName) }>{ buttonText }</Button>
                }
                    elements.push(_elements)
            }
        });
        
        return <td key={`${random}-button`}>{ elements }</td>;
    };

    const languageHandle = event => {
        const { modelType } = event;
        const modelTypeName = modelType.default;
        let element = [];

        if (content.descriptionEnglish)
            element.push(<Button key='English' type='button' variant='Info' className='language-button' onClick={ () => modelHandler(modelTypeName, 'descriptionEnglish') }>English</Button>);
        
        if (content.descriptionChinese)
            element.push(<Button key='Chinese' type='button' variant='Info' className='language-button' onClick={ () => modelHandler(modelTypeName, 'descriptionChinese') }>Chinese</Button>);
        
        if (content.descriptionSpanish)
            element.push(<Button key='Spanish' type='button' variant='Info' className='language-button' onClick={ () => modelHandler(modelTypeName, 'descriptionSpanish') }>Spanish</Button>);

        if (content.descriptionFrench)
            element.push(<Button key='French' type='button' variant='Info' className='language-button' onClick={ () => modelHandler(modelTypeName, 'descriptionFrench') }>French</Button>);

        if (content.descriptionGerman)
            element.push(<Button key='German' type='button' variant='Info' className='language-button' onClick={ () => modelHandler(modelTypeName, 'descriptionGerman') }>German</Button>);

        return <td key='language-buttons'>{ element }</td>;
    };

    const checkboxElement = () => {
        let element = null;        

        element = <Form.Check type="checkbox" className='form-checkbox' value={ id } checked={ selected.includes(id) } onChange={ event => checkboxHandler(event, content) } />
        
        return <td key={`${content.mId}-checkbox`}>{ element }</td>;
    }

    const transferHandler = () => {
        let router = `${pathname}/${id}`; 
        
        navigate(router);
    };

    const modelHandler = (modelType, data) => {
        const _content = data ? content[data] : content;

        dispatch(setModel({type: modelType, data: _content}));
    };

    const timerConvert = target => {
        const _convert = ['startDate', 'endDate'];
        let date = null;
        
        if (_convert.includes(target.key))
            date = timestamp.getDates(content[target.key]);
        else
            date = timestamp.get(content[target.key]);
        
        return date;
    };
    
    return (
        <React.Fragment>
            <tr>
                {
                    targets.map((target, index) => {
                        const { key, type } = target;
                        let value = content[key];
                        let isArray = Array.isArray(value);                        
                        const filtration = ['date', 'startDate', 'endDate', 'registerTime', 'updateTime', 'lastLoginTime', 'createTime', 'applyDate', 'time', 'requestTime', 'sendDate'];

                        if (key === 'index')
                             return indexElement();

                        else if (filtration.includes(key)) {
                            if (value !== null)
                                value = timerConvert(target);
                        }
                        else if (isArray)
                            value = value.join("\n");
                        
                        else if (key === 'link')
                            return linkElement(value);

                        else if (key === 'image' || key === 'photo') 
                            return imageElement(content.imageUrl || content.image || content.photo);
                            
                        else if (key === 'button')
                            return buttonElement(target);

                        else if (type === 'checkbox')
                            return checkboxElement();
                        
                        else if (key === 'columns') 
                            value = value.split(',').join('\n');

                        else if (key === 'language') 
                            return languageHandle(target);

                        return (
                            <td key={ key }>{ value }</td>
                        )
                    })
                }
            </tr>
        </React.Fragment>
    );
};

export default React.memo(TableList);